
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './pricing.css'; // Your custom styles
const PricingTable = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true,     // Animations should happen only once (true) or repeat (false)
        });
    }, []);

    return (
        <section id="featured-services" className="featured-services section">
            {/* Section Title */}
            <div className="container section-title" data-aos="fade-up">
                <h2>Plans & Pricing</h2>
                <p>As one of India's leading web solution providers, we are dedicated to delivering ROI-focused, customized web services at competitive prices. With our outstanding e-commerce website and graphic design expertise, Flown Developer stands out as one of the top web development companies in India.</p>
            </div>

            {/* Services */}
            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gy-5">
                    {/* Service Item 1 */}
                    <div className="col-xl-4 col-md-6 d-flex " data-aos="zoom-in" data-aos-delay="130">
                        <div className="pricing-table ">
                            <button class="standard-plan-button">Standard Plan</button>
                            <div className="price-card-image-cntnr">
                                <img className="price-card-image" src="assets/img/pricing/imgr1.png" />

                            </div>
                            <div>
                                <h3 className="price-tags">
                                    <small>
                                        <striker className="striker-price"> ₹ 14,000</striker>
                                    </small> <br />
                                    <b style={{ color: "#151AB2" }} className="main-price"> ₹ 11,999</b>
                                    <h5 className="percentage">(+18% GST Applicable)</h5>
                                </h3>
                                <h5 className="features-included-heading">Features Included </h5>
                            </div>
                            <div>

                                <ul className="feutures-list">
                                    <li>5 pages Website</li>
                                    <li>1 Year Free Domain Name (.com, .in, .org)</li>
                                    <li>1 Year Free Hosting (Unlimited Space)</li>
                                    <li>Dynamic Website (Premium Design)</li>
                                    <li>Admin Access</li>
                                    <li>Lifetime 24/7 Free Hosting Support</li>
                                    <li>Unlimited Images & Videos Upload</li>
                                    <li>Free SSL Certificates</li>

                                    <li>5 Free Email Id</li>
                                    <li>SEO Friendly Website</li>
                                    <li>100% Responsive Website</li>

                                    <li>Live Chat Integration</li>
                                    <li>Payment Gateway Integration</li>
                                    <li>Social Media Integration</li>
                                    <li>Call Button Integration</li>
                                    <li>WhatsApp Button Integration</li>
                                    <li>Inquiry Form</li>
                                    <li>1 Year
                                        Free Technical Support For Website</li>
                                    <li>Annual Renewal For Hosting Rs.3000.</li>

                                </ul>
                            </div>
                            <button className="btn-callnow"> <i class="bi bi-telephone-fill pe-2"></i>Call Now</button>

                        </div>
                    </div>
                    {/* Additional Service Items can be added here */}
                    <div class="col-xl-4 col-md-6  d-flex" data-aos="zoom-in" data-aos-delay="150">


                        <div className="pricing-table ">
                            <button class="standard-plan-button">Premium Plan</button>
                            <div className="price-card-image-cntnr">
                                <img className="price-card-image" src="assets/img/pricing/imgr2.png" />

                            </div>
                            <div>
                                <h3 className="price-tags">
                                    <small>
                                        <striker className="striker-price"> ₹ 23,000</striker>
                                    </small> <br />
                                    <b style={{ color: "#151AB2" }} className="main-price"> ₹ 19,999</b>
                                    <h5 className="percentage">(+18% GST Applicable)</h5>
                                </h3>
                                <h5 className="features-included-heading">Features Included </h5>
                            </div>
                            <div>

                                <ul className="feutures-list">
                                    <li>12 pages Website</li>
                                    <li>1 Year Free Domain Name (.com, .in, .org)</li>
                                    <li>1 Year Free Hosting (Unlimited Space)</li>
                                    <li>Dynamic Website (Premium Design)</li>
                                    <li>Admin Access</li>
                                    <li>Google
                                        Search Console Setup</li>
                                    <li>Lifetime 24/7 Free Hosting Support</li>
                                    <li>Unlimited Images & Videos Upload</li>
                                    <li>Free SSL Certificates</li>

                                    <li>10 Free Email Id</li>
                                    <li>SEO Friendly Website</li>
                                    <li>100% Responsive Website</li>
                                    <li>Live
                                        Chat Integration</li>
                                    <li>Payment Gateway Integration</li>
                                    <li>Social Media Integration</li>
                                    <li>Call Button Integration</li>
                                    <li>WhatsApp Button Integration</li>
                                    <li>Inquiry Form</li>
                                    <li>Woocommerce
                                        Features</li>
                                    <li>1 Year Free Technical Support For Website</li>
                                    <li>Annual Renewal For Hosting Rs. 3000.</li>

                                </ul>
                            </div>
                            <button className="btn-callnow"> <i class="bi bi-telephone-fill pe-2"></i>Call Now</button>

                        </div>
                        {/* <div className="infinity"></div> */}




                    </div>
                    {/* <!-- End Service Item --> */}

                    <div class="col-xl-4 col-md-6 d-flex" data-aos="zoom-in" data-aos-delay="180">


                        <div className="pricing-table ">
                            <button class="standard-plan-button">Custom Plan</button>
                            <div className="price-card-image-cntnr">
                                <img className="price-card-image" src="assets/img/pricing/imgr3.png" />

                            </div>
                            <div>
                                <h3 className="price-tags">
                                    <small>
                                        <striker className="striker-price"> ₹ ????</striker>
                                    </small> <br />
                                    <b style={{ color: "#151AB2" }} className="main-price"> ₹????</b>
                                    <h5 className="percentage">(+18% GST Applicable)</h5>
                                </h3>
                                <h5 className="features-included-heading">Features Included </h5>
                            </div>
                            <div>

                                <ul className="feutures-list">
                                    <li>Pages: According to Requirement</li>
                                    <li>1 Year Free Domain Name (.com, .in, .org)</li>
                                    <li>1 Year Free Hosting (Unlimited Space)</li>
                                    <li>Dynamic Website</li>
                                    <li>Admin Access</li>
                                    <li>Google Search Console Setup</li>
                                    <li>Lifetime 24/7 Free Hosting Support</li>
                                    <li>Unlimited Images & Videos Upload</li>
                                    <li>Free SSL Certificates</li>

                                    <li>10 Free Email Id</li>
                                    <li>SEO Friendly Website</li>
                                    <li>100% Responsive Website</li>
                                    <li>Live
                                        Chat Integration</li>
                                    <li>Payment Gateway Integration</li>
                                    <li>Social Media Integration</li>
                                    <li>Call Button Integration</li>
                                    <li>WhatsApp Button Integration</li>
                                    <li>Inquiry Form</li>
                                    <li>Woocommerce
                                        Features</li>
                                    <li>1 Year 24/7 Free Support For Website</li>
                                    <li>Annual Renewal Rs.4000</li>

                                </ul>
                            </div>
                            <button className="btn-callnow"> <i class="bi bi-telephone-fill pe-2"></i>Call Now</button>

                        </div>
                        {/* <div className="infinity"></div> */}




                    </div>
                    {/* <!-- End Service Item --> */}

                    <div class="col-xl-4 col-md-6 d-flex" data-aos="zoom-in" data-aos-delay="300">


                        <div className="pricing-table ">
                            <button class="standard-plan-button">Premium Design E-commerce Plan</button>
                            <div className="price-card-image-cntnr">
                                <img className="price-card-image" src="assets/img/pricing/imgr4.png" />

                            </div>
                            <div>
                                <h3 className="price-tags">
                                    <small>
                                        <striker className="striker-price"> ₹ 32,000</striker>
                                    </small> <br />
                                    <b style={{ color: "#151AB2" }} className="main-price"> ₹ 27,999</b>
                                    <h5 className="percentage">(+18% GST Applicable)</h5>
                                </h3>
                                <h5 className="features-included-heading">Features Included </h5>
                            </div>
                            <div>

                                <ul className="feutures-list">
                                    <li>30 pages Website</li>
                                    <li>1 Year Free Domain Name (.com, .in, .org)</li>
                                    <li>1 Year Free Hosting (Unlimited Space)</li>
                                    <li>20 Product Categories</li>
                                    <li>30 Product Listing From Our Side</li>
                                    <li>Premium Design</li>
                                    <li>Dynamic Website</li>
                                    <li>Admin Access</li>
                                    <li>Google Search Console Setup</li>
                                    <li>Lifetime 24/7 Free Hosting Support</li>
                                    <li>Unlimited Images & Videos Upload</li>
                                    <li>Free SSL Certificates</li>

                                    <li>10 Free Email Id</li>
                                    <li>Premium Theme</li>
                                    <li>SEO Friendly Website</li>
                                    <li>100% Responsive Website</li>
                                    <li>Live Chat Integration</li>
                                    <li>Payment Gateway Integration</li>

                                    <li>Social Media Integration</li>
                                    <li>Call Button Integration</li>
                                    <li>WhatsApp Button Integration</li>
                                    <li>Inquiry Form</li>
                                    <li>Ecommerce
                                        Features</li>
                                    <li>Product Variation Features</li>
                                    <li>Auto Invoice Bill Generator Features</li>
                                    <li>Wallet System Features</li>
                                    <li>Order Notification Features</li>
                                    <li>OTP Verification Features</li>
                                    <li>1 Year Free Technical Support For Website</li>
                                    <li>Annual Renewal For Hosting Rs.4000.</li>

                                </ul>
                            </div>
                            <button className="btn-callnow"> <i class="bi bi-telephone-fill pe-2"></i>Call Now</button>

                        </div>
                        {/* <div className="infinity"></div> */}




                    </div>
                    {/* <!-- End Service Item --> */}

                    <div class="col-xl-4 col-md-6 d-flex" data-aos="zoom-in" data-aos-delay="300">


                        <div className="pricing-table ">
                            <button class="standard-plan-button">Multi-vendor Business & E-commerce Plan</button>
                            <div className="price-card-image-cntnr">
                                <img className="price-card-image" src="assets/img/pricing/imgr5.png" />

                            </div>
                            <div>
                                <h3 className="price-tags">
                                    <small>
                                        <striker className="striker-price"> ₹ 83,000</striker>
                                    </small> <br />
                                    <b style={{ color: "#151AB2" }} className="main-price"> ₹ 69,999</b>
                                    <h5 className="percentage">(+18% GST Applicable)</h5>
                                </h3>
                                <h5 className="features-included-heading">Features Included </h5>
                            </div>
                            <div>

                                <ul className="feutures-list">
                                    <li>40 pages Website</li>
                                    <li>1 Year Free Domain Name (.com, .in, .org)</li>
                                    <li>1 Year Free Hosting (Unlimited Space)</li>
                                    <li>50 Products Categories</li>
                                    <li>30 Products Listing from our side</li>
                                    <li>Premium Design</li>
                                    <li>Dynamic Website</li>
                                    <li>Admin Access</li>
                                    <li>Google Search Console Setup</li>
                                    <li>Dynamic Multi-Vendor Website</li>
                                    <li>Lifetime 24/7 Free Hosting Support</li>
                                    <li>Unlimited Images & Videos Upload</li>
                                    <li>Free SSL Certificates</li>
                                    <li>20 Free Email Id</li>
                                    <li>SEO Friendly Website</li>
                                    <li>100% Responsive Website</li>
                                    <li>Live Chat Integration</li>
                                    <li>Payment Gateway Integration</li>
                                    <li>Social Media Integration</li>
                                    <li>Call Button Integration</li>
                                    <li>WhatsApp Button Integration</li>
                                    <li>Inquiry Form</li>
                                    <li>Multi-Level
                                        Ecommerce Features</li>
                                    <li>Product Variation Features</li>
                                    <li>Auto Invoice Bill Generator Features</li>
                                    <li>Wallet System Features</li>
                                    <li>Order Notification Features</li>
                                    <li>OTP Verification Features</li>
                                    <li>1 Year Free Technical Support For Website</li>
                                    <li>Annual Renewal For Hosting Rs.3000.</li>

                                </ul>
                            </div>
                            <button className="btn-callnow"> <i class="bi bi-telephone-fill pe-2"></i>Call Now</button>

                        </div>
                        {/* <div className="infinity"></div> */}




                    </div>
                    {/* <!-- End Service Item --> */}

                    <div class="col-xl-4 col-md-6 d-flex" data-aos="zoom-in" data-aos-delay="300">


                        <div className="pricing-table ">
                            <button class="standard-plan-button">Custom Multi-vendor Business & E-commerce Plan</button>
                            <div className="price-card-image-cntnr">
                                <img className="price-card-image" src="assets/img/pricing/imgr7.png" />

                            </div>
                            <div>
                                <h3 className="price-tags">
                                    <small>
                                        <striker className="striker-price"> ₹ ????</striker>
                                    </small> <br />
                                    <b style={{ color: "#151AB2" }} className="main-price"> ₹ ????</b>
                                    <h5 className="percentage">(+18% GST Applicable)</h5>
                                </h3>
                                <h5 className="features-included-heading">Features Included </h5>
                            </div>
                            <div>

                                <ul className="feutures-list">
                                    <li>Pages: According to the requirements</li>
                                    <li>1 Year Free Domain Name (.com, .in, .org)</li>
                                    <li>1 Year Free Hosting (Unlimited Space)</li>
                                    <li>?? Products Categories</li>
                                    <li>?? Products Listing from our side</li>
                                    <li>Premium Design</li>
                                    <li>Dynamic Website</li>
                                    <li>Admin Access</li>
                                    <li>Google Search Console Setup</li>
                                    <li>Dynamic Multi-Vendor Website</li>
                                    <li>Lifetime 24/7 Free Hosting Support</li>
                                    <li>Unlimited Images & Videos Upload</li>
                                    <li>Free SSL Certificates</li>
                                    <li>20 Free Email Id</li>
                                    <li>SEO Friendly Website</li>
                                    <li>100% Responsive Website</li>
                                    <li>Live Chat Integration</li>
                                    <li>Payment Gateway Integration</li>
                                    <li>Social Media Integration</li>
                                    <li>Call Button Integration</li>
                                    <li>WhatsApp Button Integration</li>
                                    <li>Inquiry Form</li>
                                    <li>Multi-Level Ecommerse Features</li>
                                    <li>Product Variation Features</li>
                                    <li>Auto Invoice Bill Generator Features</li>
                                    <li>Wallet System Features</li>
                                    <li>Order Notification Features</li>
                                    <li>OTP Verification Features</li>
                                    <li>1 Year Free Technical Support For Website</li>
                                    <li>Annual Renewal For Hosting Rs.3000.</li>

                                </ul>
                            </div>
                            <button className="btn-callnow"> <i class="bi bi-telephone-fill pe-2"></i>Call Now</button>

                        </div>
                        {/* <div className="infinity"></div> */}




                    </div>
                    {/* <!-- End Service Item --> */}
                    {/* Service Item 1 */}

                </div>

            </div>

        </section>
    )
}
export default PricingTable